import { useTranslation } from 'react-i18next'

import { UsersThreeIcon } from '@phosphor-icons/react'

import { Button, ButtonWithSpinner, CardTitle } from '@reveni-io/reveni-ui'

import ViewVisibilityFields from '@/common/components/FilterViews/ViewVisibilityFields/ViewVisibilityFields'

import useManageVisibilityForm from './hooks/useManageVisibilityForm/useManageVisibilityForm'
import * as Styles from './styles'

const ManageVisibilityForm = ({
  view,
  groups,
  ownGroupIds,
  canSelectGroups,
  loadingGroups,
  saving,
  onCancel,
  onSave,
}) => {
  const { t } = useTranslation()
  const {
    visibility,
    setVisibility,
    selectedGroupIds,
    fixedGroupIds,
    toggleGroup,
    selectedGroups,
    showSharedGroupsAlert,
    showGroupsWithAccess,
    isFormValid,
    hasChanges,
    handleSave,
  } = useManageVisibilityForm({ view, groups, ownGroupIds, canSelectGroups, onSave })

  return (
    <Styles.Container>
      <CardTitle Icon={UsersThreeIcon}>{t('Gestionar visibilidad de "{{name}}"', { name: view.name })}</CardTitle>
      <Styles.Content>
        <ViewVisibilityFields
          visibility={visibility}
          onChangeVisibility={setVisibility}
          groups={groups}
          selectedGroupIds={selectedGroupIds}
          fixedGroupIds={fixedGroupIds}
          selectedGroups={selectedGroups}
          showSharedGroupsAlert={showSharedGroupsAlert}
          showGroupsWithAccess={showGroupsWithAccess}
          loadingGroups={loadingGroups}
          onToggleGroup={toggleGroup}
        />
      </Styles.Content>
      <Styles.Footer>
        <Button variant="outlined" fullWidth onClick={onCancel}>
          {t('Cancelar')}
        </Button>
        <ButtonWithSpinner
          fullWidth
          onClick={handleSave}
          defaultLabel={t('Guardar cambios')}
          loadingLabel={t('Guardando')}
          loading={saving}
          disabled={saving || !isFormValid || !hasChanges}
        />
      </Styles.Footer>
    </Styles.Container>
  )
}

export default ManageVisibilityForm
